import React, {
  createRef,
  useEffect,
  useMemo,
  useState,
  useContext,
} from 'react';

import useCanBackStep from 'hooks/useCanBackStep';
import useLocalStorage from 'hooks/useLocalStorage';
import { HashContext } from 'contexts/HashContext';
import PersonalDataModal from './PersonalDataModal';
import PersonalDataForm from './PersonalDataForm';

export default function PersonalDataRegister() {
  useCanBackStep();
  const { isArteris } = useContext(HashContext);

  const form = createRef(null);
  const [storageValues, setStorageValues] = useLocalStorage('@step-one');
  const [canBack] = useLocalStorage('@can-back');
  const [isCompleted, setCompleted] = useState(false);

  const initialValues = useMemo(() => {
    const emptyValues = {
      fullname: '',
      email: '',
      phone: '',
      nacionality: '',
      maritalStatus: '',
      pcd: '',
      gender: '',
      bornDate: '',
      cpf: '',
      rg: '',
      rg_emissor: '',
      rg_uf: '',
      rg_data_emissao: '',
      filiacao_pai: '',
      filiacao_mae: '',
    };

    if (!storageValues) {
      setStorageValues(emptyValues);
    }

    return storageValues;
  }, [setStorageValues, storageValues]);

  useEffect(() => {
    if (canBack) {
      return;
    }

    if (Object.values(initialValues).every((obj) => obj !== '')) {
      setCompleted(true);
    }
  }, [storageValues, canBack, initialValues]);

  function handleSave() {
    setStorageValues(form.current.values);
  }

  return (
    <>
      <PersonalDataModal />
      <PersonalDataForm
        isArteris={isArteris}
        onChangeSave={handleSave}
        isCompleted={isCompleted}
        initialValues={initialValues}
        form={form}
      />
    </>
  );
}
